<template>
  <div class="card mb-4">
    <div class="card-body pb-3">
      <div class="d-flex flex-wrap">
        <oms-filter-statuses
          :title="t('features.product_request.filters.product_request_status')"
          icon="ri-ship-line"
          :statuses="productRequestStatuses"
          v-model="filters.product_request_statuses"
          color="secondary"
        />
        <oms-filter-statuses
          :title="t('features.product_request.filters.stock_destination_type')"
          icon="ri-ship-line"
          :statuses="stockDestinationTypes"
          v-model="filters.stock_destination_types"
          color="secondary"
        />
        <oms-filter-date-range
          :title="t('features.product_request.filters.requested_delivery_at')"
          icon="ri-map-pin-time-line"
          v-model="filters.requested_delivery_at"
        />
        <oms-filter-radio-buttons
          :title="t('features.product_request.filters.paid_status')"
          icon="ri-links-fill"
          :options="paidStatuses"
          v-model="filters.paid_statuses"
        />
        <oms-filter-radio-buttons
          :title="t('features.product_request.filters.payment_type')"
          icon="ri-links-fill"
          :options="paymentTypes"
          v-model="filters.payment_types"
        />
      </div>
      <div class="d-flex align-items-start mt-2">
        <div
          class="form-inline flex-grow-1 mr-2 mb-2"
          :title="t('features.product_request.filters.search_tooltip')"
        >
          <input
            class="form-control w-100"
            v-model="filters.keyword"
            @keyup.enter="submit"
            type="text"
            :placeholder="t('features.product_request.filters.search_placeholder')"
          />
        </div>

        <button class="btn btn-primary mb-2 text-nowrap" @click="submit" :disabled="isLoading || !isDirty">
          <span class="ri-search-line"></span> {{ t('features.product_request.filters.search') }}
        </button>
      </div>
    </div>

    <div class="card-body pt-0 pb-1">
      <oms-filter-content-statuses
        :title="t('features.product_request.filters.product_request_status')"
        :statuses="productRequestStatuses"
        :modelValue="filters.product_request_statuses"
        color="secondary"
      />
      <oms-filter-content-statuses
        :title="t('features.product_request.filters.stock_destination_type')"
        :statuses="stockDestinationTypes"
        :modelValue="filters.stock_destination_types"
        color="secondary"
      />
      <oms-filter-content-date-range
        :title="t('features.product_request.filters.requested_delivery_at')"
        :modelValue="filters.requested_delivery_at"
      />
      <oms-filter-content-basic
        :title="t('features.product_request.filters.paid_status')"
        default-value="all"
        :mapping="paidStatuses"
        :modelValue="filters.paid_statuses"
      />
      <oms-filter-content-basic
        :title="t('features.product_request.filters.payment_type')"
        default-value="all"
        :mapping="paymentTypes"
        :modelValue="filters.payment_types"
      />
    </div>
  </div>
</template>

<script>
import buildQueryString from '../../../helpers/query-builder'
import OmsFilterStatuses from '../filter/statuses.vue'
import OmsFilterRadioButtons from '../filter/radio-buttons.vue'
import OmsFilterDateRange from '../filter/date-range.vue'
import OmsFilterContentDateRange from '../filter-content/date-range.vue'
import OmsFilterContentStatuses from '../filter-content/statuses.vue'
import OmsFilterContentBasic from '../filter-content/basic.vue'

export default {
  inject: ['i18n'],

  props: {
    initialData: Object
  },

  data() {
    this.initialData.filters = {
      ...this.initialData.filters,
      // This is 2 lines are here because the backend sends a `[]`, probably it's better to fix the backend
      paid_statuses:
        typeof this.initialData.filters?.paid_statuses == 'string'
          ? this.initialData.filters.paid_statuses
          : 'all',
      payment_types:
        typeof this.initialData.filters?.payment_types == 'string'
          ? this.initialData.filters.payment_types
          : 'all'
    }

    return {
      ...this.initialData,
      isLoading: false,
      isDirty: false
    }
  },

  computed: {
    searchUrl() {
      return `${this.baseUrl}?${this.filterQueryString}`
    },

    filterQueryString() {
      return buildQueryString(this.filters, 'q')
    },

    t() {
      return (key, options) => this.i18n.t(key, options)
    }
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.isDirty = true
      }
    }
  },

  methods: {
    submit() {
      this.isDirty = false
      this.isLoading = true

      window.location.href = this.searchUrl
    }
  },

  components: {
    OmsFilterStatuses,
    OmsFilterRadioButtons,
    OmsFilterDateRange,
    OmsFilterContentDateRange,
    OmsFilterContentStatuses,
    OmsFilterContentBasic
  }
}
</script>
